export default __webpack_public_path__ + "static/media/trailer.5006ac28.mp4";